import { utcDateStr } from '../lib/dateUtils';
import { sentimentRangeFor, type SentimentRange, type TimePeriod } from '../campaign-reporting/reportingWindow';
import { useCampaignReportingWindow } from './useCampaignReportingWindow';

/** The Sentiment tab's window: the shared `?win` preset and the UTC day range it resolves to. */
export function useSentimentRange(): {
  preset: TimePeriod;
  range: SentimentRange;
  setPreset: (p: TimePeriod) => void;
} {
  const { window: preset, setWindow } = useCampaignReportingWindow();
  return { preset, range: sentimentRangeFor(preset, utcDateStr()), setPreset: setWindow };
}
